import { Select, Space } from 'antd'
import { useTranslation } from 'react-i18next'
import { useVispOptions } from '@/shared/api/reference'
import { useTableUrlState } from '@/shared/ui/table/useTableUrlState'

/** Partiyalar ro'yxatini VISP yoki Center bo'yicha toraytiradi — holat URL'da (`visp`, `center`). */
export function VoucherBatchNetworkFilter() {
  const { t } = useTranslation()
  const { state, patch } = useTableUrlState()
  const visps = useVispOptions()
  const centers = [...new Map(visps.map((v) => [v.centerId, v.centerName])).entries()]

  const set = (key: 'visp' | 'center', value: string | undefined) =>
    patch({ page: 1, filters: { ...state.filters, [key]: value ? [value] : [] } })

  return (
    <Space wrap size="small">
      <Select
        allowClear
        showSearch
        optionFilterProp="label"
        style={{ minWidth: 180 }}
        placeholder={t('voucher.batch.filterCenter')}
        value={state.filters['center']?.[0]}
        onChange={(value?: string) => set('center', value)}
        options={centers.map(([id, name]) => ({ value: id, label: name }))}
      />
      <Select
        allowClear
        showSearch
        optionFilterProp="label"
        style={{ minWidth: 200 }}
        placeholder={t('voucher.batch.filterVisp')}
        value={state.filters['visp']?.[0]}
        onChange={(value?: string) => set('visp', value)}
        options={visps.map((v) => ({ value: v.id, label: `${v.centerName} / ${v.name}` }))}
      />
    </Space>
  )
}
